module.exports = __webpack_public_path__ + "cbe297d1ea7bf5aac3cfcd540c8be570.png";